import SvgIcon from '@mui/material/SvgIcon'
import { WithRecord } from 'react-admin'

import CircularGaugeIcon from '../CircularGaugeIcon'
import UnitField from '../UnitField'
import FieldRow from './FieldRow'

const CarBatteryIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Battery outline */}
    <rect x={3} y={7} width={18} height={10} rx={2} ry={2} stroke="currentColor" strokeWidth={2} fill="none" />
    {/* Terminals */}
    <rect x={7} y={4} width={2} height={3} fill="currentColor" />
    <rect x={15} y={4} width={2} height={3} fill="currentColor" />

    {/* Plus sign */}
    <path d="M7 12h4M9 10v4" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    {/* Minus sign */}
    <line x1={15} y1={12} x2={19} y2={12} stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
  </SvgIcon>
)

const BATTERY_THRESHOLDS_ENGINE_ON = [
  { limit: 13.0, color: '#d32f2f', label: 'battery.on.tooLow' },
  { limit: 13.6, color: '#ed6c02', label: 'battery.on.low' },
  { limit: 14.8, color: '#1fd92e', label: 'battery.on.normal' },
  { limit: 15.1, color: '#ed6c02', label: 'battery.on.high' },
  { limit: Infinity, color: '#d32f2f', label: 'battery.on.danger' },
]

const BATTERY_THRESHOLDS_ENGINE_OFF = [
  { limit: 11.7, color: '#d32f2f', label: 'battery.off.critical' },
  { limit: 12.2, color: '#ed6c02', label: 'battery.off.low' },
  { limit: 12.7, color: '#1fd92e', label: 'battery.off.healthy' },
  { limit: Infinity, color: '#ed6c02', label: 'battery.off.high' },
]

const Battery12VField = () => (
  <WithRecord
    render={(record) => (
      <FieldRow
        icon={
          <CircularGaugeIcon
            value={record.battery_voltage.toFixed(1)}
            thresholds={record.engine_running ? BATTERY_THRESHOLDS_ENGINE_ON : BATTERY_THRESHOLDS_ENGINE_OFF}
            Icon={CarBatteryIcon}
          />
        }
      >
        <UnitField source="battery_voltage" formatValue={(v) => v.toFixed(1)} unit="V" />
      </FieldRow>
    )}
  />
)

export default Battery12VField
